// format `12345678` to `12 345 678`
export function formatInteger(integer: number | null) {
    if (integer === null) {
        return '';
    }

    return integer
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
